// src/lib/validationUtils.js
export const passwordRules = {
  minLength: 10,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSymbol: true
};

// Email validation
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Password validation
export const validatePassword = (password) => {
  const errors = [];
  
  if (password.length < passwordRules.minLength) {
    errors.push(`Password must be at least ${passwordRules.minLength} characters long`);
  }
  
  if (passwordRules.requireUppercase && !/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (passwordRules.requireLowercase && !/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (passwordRules.requireNumber && !/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  // eslint-disable-next-line no-useless-escape
  if (passwordRules.requireSymbol && !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push('Password must contain at least one symbol');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

// Password strength calculator
export const calculatePasswordStrength = (password) => {
  let score = 0;
  const checks = {
    length: password.length >= passwordRules.minLength,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /\d/.test(password),
    // eslint-disable-next-line no-useless-escape
    symbol: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
  };
  
  Object.values(checks).forEach(check => {
    if (check) score++;
  });
  
  return {
    score,
    checks,
    strength: score <= 2 ? 'weak' : score <= 3 ? 'medium' : score <= 4 ? 'strong' : 'very-strong'
  };
};

// Generic form field validation
export const validateRequired = (value, fieldName) => {
  if (!value || !value.toString().trim()) {
    return `${fieldName} is required`;
  }
  return null;
};

// Validate entire personal details form
export const validatePersonalDetailsForm = (formData, t) => {
  const errors = {};
  
  if (!formData.firstName?.trim()) {
    errors.firstName = t('signup.errors.allFieldsRequired');
  }
  
  if (!formData.lastName?.trim()) {
    errors.lastName = t('signup.errors.allFieldsRequired');
  }
  
  if (!formData.brokerage) {
    errors.brokerage = t('signup.errors.allFieldsRequired');
  }
  
  if (!formData.email?.trim()) {
    errors.email = t('signup.errors.allFieldsRequired');
  } else if (!validateEmail(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Validate password form
export const validatePasswordForm = (formData, t) => {
  const errors = {};
  
  if (!formData.password) {
    errors.password = t('signup.errors.allFieldsRequired');
  } else {
    const passwordValidation = validatePassword(formData.password);
    if (!passwordValidation.isValid) {
      errors.password = t('signup.errors.passwordRequirements');
    }
  }
  
  if (!formData.confirmPassword) {
    errors.confirmPassword = t('signup.errors.allFieldsRequired');
  } else if (formData.password !== formData.confirmPassword) {
    errors.confirmPassword = t('signup.errors.passwordMismatch');
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};